import { Typography, Box } from "@mui/material";
import { MzTabContext, MzTab, MzTabList, MzTabPanel } from "@markaaz/ui/MzTabControls";
import AccountInformation from "./AccountInformation";
import AccountSecurity from "./AccountSecurity";

const sx = {
  header: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "40px"
  },

  title: {
    h4: {
      color: "darkBlue.c100"
    },
    flexGrow: 1
  }
};

export default function MyAccountMain({
  selectedTab,
  userData,
  showNotification,
  onhandleTabChange,
  onSubmit,
  onChangePassword,
  dialogOpen,
  countDownLogout,
  onClose,
  loading,
  loadingReset,
  onAlertClose
}) {
  return (
    <Box>
      <Box sx={sx.header}>
        <Box sx={sx.title}>
          <Typography variant="h4">My Account</Typography>
        </Box>
      </Box>

      <MzTabContext value={selectedTab}>
        <MzTabList onChange={onhandleTabChange}>
          <MzTab label="Account Information" value="1" />
          <MzTab label="Account Security" value="2" />
        </MzTabList>

        <MzTabPanel value="1" sx={{ paddingBottom: 0 }}>
          <AccountInformation
            userData={userData}
            onSubmit={onSubmit}
            loading={loading}
            showNotification={showNotification}
            onAlertClose={onAlertClose}
          />
        </MzTabPanel>

        <MzTabPanel value="2" sx={{ paddingBottom: 0 }}>
          <AccountSecurity
            onSubmit={onChangePassword}
            dialogOpen={dialogOpen}
            countDownLogout={countDownLogout}
            showNotification={showNotification}
            onClose={onClose}
            onAlertClose={onAlertClose}
            userData={userData}
            loading={loadingReset}
          />
        </MzTabPanel>
      </MzTabContext>
    </Box>
  );
}
